/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosCard, CosmosRichText, CosmosText, CosmosTextVariantEnum, EdsIcon } from "@components/elements";
import { LicenseCollapsedCardFragment } from "@cosmos/hygraph-schema";
import { css } from "@panda/css";
import { Stack } from "@panda/jsx";

export function LicenseCollapsedCard({ icon, title, description }: LicenseCollapsedCardFragment): React.JSX.Element {
	return (
		<CosmosCard className="license-collapsed-card" padding={32} variant="material">
			<Stack gap="eds.dimension.16">
				<Stack alignItems="center" gap="eds.dimension.16" direction="row">
					<EdsIcon icon={icon} />
					{title ? (
						<CosmosText variant={CosmosTextVariantEnum.headingLG} as="h4" text={title} color="eds.text.primary" />
					) : null}
				</Stack>
				{description?.html ? (
					<CosmosRichText
						className={css({
							"& strong": {
								color: "eds.text.primary",
							},
						})}
						variant={CosmosTextVariantEnum.paragraphMD}
						color="eds.text.secondary"
						html={description?.html}
					/>
				) : null}
			</Stack>
		</CosmosCard>
	);
}
